import React from "react";
import { createRoot } from "react-dom/client";
import { configure as configureMobX } from "mobx";
import initialzeAmplify from "./services/AmplifyService";
import { initializePostHog, captureEvent } from "./services/PostHogService";
import App from "./app";
import "./styles/index.scss";

// --- Global Error Handlers
window.onerror = function (message, source, lineno, colno, error) {
  captureEvent('uncaught_exception', {
    message: message,
    source: source,
    lineno: lineno,
    colno: colno,
    error: error ? error.stack : null,
  });
  return false; // Don't prevent default handling
};

window.onunhandledrejection = function (event) {
  captureEvent('unhandled_rejection', {
    reason: event.reason ? event.reason.stack : 'unknown',
  });
};
// ---

configureMobX({ enforceActions: "never" });
initialzeAmplify();
initializePostHog();

const root = createRoot(document.getElementById("root"));
root.render(<App />);
